import {Patient} from "./patient.model";

class Needle {
  color: string;
  label: string;
}

const NeedleTypes: {[key: string] : Needle} = {
  blu : { color : "#0000FF", label : "BLEU" },
  rose : { color : "#FF69B4", label : "ROSE" },
  yellow : { color : "#fed400", label : "JAUNE" },
};


export class ChocResults {

  needles: Needle[] = [];
  needleColor: string;
  needleLabel: string;
  needleAmount: number;
  X: number;
  Y: number;
  dubo: number;
  duboX: number;
  duboY: number;
  adreY: number;
  adreX: number;

  constructor(patient: Patient) {
    this.initResults(patient)
  }

  private initResults(patient: Patient) {
    if (patient.weight > 70) {
      this.needles = [NeedleTypes.blu, NeedleTypes.yellow]
    } else if (patient.weight > 20) {
      this.needles = [NeedleTypes.blu]
    } else {
      this.needles = [NeedleTypes.rose]
    }
    this.needleAmount = Math.min( Math.round(2 * patient.weight)*10, 1500);
    this.Y = Math.round((patient.weight * 0.3)*10)/10;
    let choc_x_value = (this.Y); //NOTE: mg = ml for Noradrenaline
    this.X = Math.round(choc_x_value * 10) / 10;

    const coeff = (patient.weight > 15 ? 3 : 15); //TODO verify formula
    this.duboY = Math.floor(patient.weight * coeff * 10) / 10;
    this.duboX = Math.round(patient.weight * coeff * 0.08 * 10) / 10;

    this.adreY = Math.round( (patient.weight * 0.3) * 100) / 100;
    this.adreX = Math.round(patient.weight * 30) / 100;

  }
}



// WEBPACK FOOTER //
// ./src/models/choc-results.model.ts